import React from "react";
import { isString } from "@common/helpers/typeGuards";
import {
    RuleConditionType,
    TransactionRuleCondition,
} from "@common/types/transactionRule";
import { Tag } from "@design-system/Tag/Tag";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { RuleTagRow } from "../RuleTagRow";
import { RULE_TAG_PROPS } from "../ruleTagUtils";

interface Props {
    condition: TransactionRuleCondition;
}

const localizeOperator = (operator: RuleConditionType) => {
    switch (operator) {
        case RuleConditionType.DESCRIPTION_INCLUDES:
            return "Contains";
        case RuleConditionType.DESCRIPTION_DOES_NOT_INCLUDE:
            return "Does not contain";
        default:
            return "Is";
    }
};

export const RuleDescriptionCondition: React.FC<Props> = ({ condition }) => {
    const operator = localizeOperator(condition.conditionType);

    if (
        isString(condition.value) ||
        (Array.isArray(condition.value) && condition.value.length === 1)
    ) {
        const value = isString(condition.value)
            ? condition.value
            : condition.value[0];

        return (
            <RuleTagRow label="Bank description" type="condition">
                <Tag {...RULE_TAG_PROPS}>{operator}</Tag>
                <Tag {...RULE_TAG_PROPS}>{value as string}</Tag>
            </RuleTagRow>
        );
    }

    if (Array.isArray(condition.value)) {
        const [firstValue, ...otherValues] = condition.value;

        return (
            <RuleTagRow label="Bank description" type="condition">
                <Tag {...RULE_TAG_PROPS}>{operator}</Tag>
                <Tag {...RULE_TAG_PROPS}>{firstValue as string}</Tag>
                <Tooltip content={otherValues.join(", ")}>
                    <span>
                        <Tag {...RULE_TAG_PROPS} numeric>
                            + {otherValues.length}
                        </Tag>
                    </span>
                </Tooltip>
            </RuleTagRow>
        );
    }

    return null;
};
